/*
 * AdminSettings Messages
 *
 * This contains all the text for the AdminSettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.AdminSettings.theme',
    defaultMessage: 'Theme',
  },
  intro: {
    id: 'app.components.AdminSettings.themeIntro',
    defaultMessage: 'Adapt the colors, logo, and tagline of the School App to the style and vision of your school.',
  },
  adaptTheme: {
    id: 'app.components.AdminSettings.adaptTheme',
    defaultMessage: 'Adapt Theme',
  },
  logo: {
    id: 'app.components.AdminGroupDetails.logo',
    defaultMessage: 'Logo',
  },
  themeColor: {
    id: 'app.components.AdminSettings.themeColor',
    defaultMessage: 'Theme Color',
  },
  tagLine: {
    id: 'app.components.AdminGroupDetails.tagLine',
    defaultMessage: 'Tagline',
  },
  backgroundImage: {
    id: 'app.components.AdminSettings.backgroundImage',
    defaultMessage: 'Background Image',
  },
  noBackgroundImage: {
    id: 'app.components.AdminSettings.noBackgroundImage',
    defaultMessage: 'No background image',
  },
  filterAll: {
    id: 'app.components.CommunityPosts.filterAll',
    defaultMessage: 'All Messages',
  },
  myGroups: {
    id: 'app.components.SideMenu.myGroups',
    defaultMessage: 'My Groups',
  },
});
